<div class="auth-container">
    <div class="texture-top"></div>
    <div class="auth-warpper d-flex w-100 h-100 align-items-center justify-content-center">
        <!-- <div class="login-component-form position-relative" *ngIf="step == 'verify-code'">
            <img class="logo-icon" src="../../../../assets/images/logo-icon.png" alt="logo icon" />

            <div class="form-control">
                <h3 class="algin-center font-bold txt-welcome-back">{{ 'VerificationCode.Name' | translate }}</h3>
                <p class="algin-center line-text">{{ 'VerificationCode.EnterEmailVerify' | translate }}</p>
                <p class="algin-center line-text">{{ 'VerificationCode.ThroughEmail' | translate }}</p>

                <form class="form-auth form-submit-code">
                    <code-input
                        [isCodeHidden]="false"
                        [codeLength]="6"
                        (codeChanged)="onCodeChanged($event)"
                        [ngClass]="user?.code.length != 6 && isChangeCode ? 'code-error' : ''"
                        (codeCompleted)="onCodeCompleted($event)"
                    >
                    </code-input>
                    <mat-error *ngIf="user?.code.length != 6 && isChangeCode" style="padding-left: 6px">{{
                        'ValidationMessage.RequiredCode' | translate
                    }}</mat-error>
                    <button mat-button class="btn-sign-in" (click)="confirmSignUp()">{{ 'Submit' | translate }}</button>
                </form>
            </div>
        </div> -->

        <div class="login-component-form position-relative is-congratulations">
            <img class="logo-icon" src="../../../../assets/images/logo-icon.png" alt="logo icon" />
            <div class="warrper-reset successfuly">
                <div class="warrper-text-image">
                    <div class="image d-flex justify-content-center">
                        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M59 30C59 46.0047 46.0169 58.9803 30 58.9803C13.9831 58.9803 1 46.0047 1 30C1 13.9952 13.9831 1.01965 30 1.01965C46.0169 1.01965 59 13.9952 59 30Z"
                                fill="#17B978"
                                stroke="#333333"
                                stroke-width="2"
                            />
                            <path
                                d="M27.5945 45.9469L13.4102 34.8966L17.4433 29.7206L26.1536 36.5063L40.5292 15.7622L45.9236 19.4991L27.5945 45.9469Z"
                                fill="white"
                                stroke="#333333"
                                stroke-width="2"
                            />
                        </svg>
                    </div>
                    <div class="text">
                        <h2 class="font-bold algin-center m-0">{{ 'SignUpProfile.Congratulations' | translate }}!</h2>
                        <h2 class="font-bold algin-center m-0">{{ 'SignUpProfile.MessageSuccess' | translate }}</h2>
                    </div>
                </div>
                <button mat-button class="btn-sign-in m-0" (click)="gotoDashboard()">
                    {{ 'Btn_GoToDashboard' | translate }}
                </button>
            </div>
        </div>
    </div>
    <div class="texture-bottom"></div>
</div>
